"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _dateFns = require("date-fns");
var _helpers = require("../../utils/helpers");
var _AirDateFormatterModule = _interopRequireDefault(require("../../scss/utils/AirDateFormatter.module.scss"));
function AirDateFormatter(_ref) {
  let {
    airdateStr = null,
    separatorType = 'none'
  } = _ref;
  if (airdateStr === null) return /*#__PURE__*/_react.default.createElement("airdate-formatter", {
    class: "no-airdate"
  }, "\xA0");
  const airdate = new Date(airdateStr.replace(' ', 'T'));
  const centralAirdate = (0, _dateFns.sub)(airdate, {
    hours: 1
  });
  const minutes = airdate.getMinutes() === 0 ? '' : (0, _dateFns.format)(airdate, ':mm');
  const timeSection = "".concat((0, _dateFns.format)(airdate, 'h')).concat(minutes).concat(Number.parseInt((0, _dateFns.format)(airdate, 'H'), 10) < 12 ? 'a' : '');
  const centralTime = "".concat((0, _dateFns.format)(centralAirdate, 'h')).concat(minutes);
  //const meridian = `${format(airdate, 'aa')}`

  let daySection = "".concat((0, _dateFns.format)(airdate, 'ccc'));
  let dateSection = '';
  const today = new Date();
  const tomorrow = (0, _dateFns.add)(today, {
    days: 1
  });
  // determine what string to use for the day and date sections
  if ("".concat(today.getFullYear()).concat(today.getMonth()).concat(today.getDate()) === "".concat(airdate.getFullYear()).concat(airdate.getMonth()).concat(airdate.getDate())) {
    daySection = 'Today';
  } else if ("".concat(tomorrow.getFullYear()).concat(tomorrow.getMonth()).concat(tomorrow.getDate()) === "".concat(airdate.getFullYear()).concat(airdate.getMonth()).concat(airdate.getDate())) {
    daySection = 'Tomorrow';
  } else {
    dateSection = "".concat((0, _dateFns.format)(airdate, 'LLL d'));
  }
  switch (separatorType) {
    case 'pipe':
      return /*#__PURE__*/_react.default.createElement("airdate-formatter", null, /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _helpers.classes)([_AirDateFormatterModule.default['airdate-formatter__date'], 'airdate-formatter__date'])
      }, daySection === 'Today' || daySection === 'Tomorrow' ? daySection : "".concat(daySection, ", ").concat(dateSection)), /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _helpers.classes)([_AirDateFormatterModule.default['airdate-formatter__pipe'], 'airdate-formatter__pipe'])
      }, " | "), /*#__PURE__*/_react.default.createElement("span", {
        className: "airdate-formatter__time-wrap"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "airdate-formatter__time"
      }, timeSection), "/", minutes !== '' ? /*#__PURE__*/_react.default.createElement("br", null) : null, /*#__PURE__*/_react.default.createElement("span", {
        className: "airdate-formatter__central-time"
      }, centralTime, /*#__PURE__*/_react.default.createElement("span", null, "c"))));
    case 'line-break':
      return /*#__PURE__*/_react.default.createElement("airdate-formatter", null, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _helpers.classes)([_AirDateFormatterModule.default['airdate-formatter__day'], 'airdate-formatter__day'])
      }, daySection), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _helpers.classes)([_AirDateFormatterModule.default['airdate-formatter__date'], 'airdate-formatter__date'])
      }, dateSection), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _helpers.classes)([_AirDateFormatterModule.default['airdate-formatter__time-wrap'], 'airdate-formatter__time-wrap'])
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "airdate-formatter__time"
      }, timeSection), "/", minutes !== '' ? /*#__PURE__*/_react.default.createElement("br", null) : null, /*#__PURE__*/_react.default.createElement("span", {
        className: "airdate-formatter__central-time"
      }, centralTime, /*#__PURE__*/_react.default.createElement("span", null, "c"))));
    case 'single-line-break':
      return /*#__PURE__*/_react.default.createElement("airdate-formatter", null, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _helpers.classes)([_AirDateFormatterModule.default['airdate-formatter__day'], 'airdate-formatter__day'])
      }, daySection, " ", /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _helpers.classes)([_AirDateFormatterModule.default['airdate-formatter__date'], 'airdate-formatter__date'])
      }, dateSection)), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _helpers.classes)([_AirDateFormatterModule.default['airdate-formatter__time-wrap'], 'airdate-formatter__time-wrap'])
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "airdate-formatter__time"
      }, timeSection), "/", minutes !== '' ? /*#__PURE__*/_react.default.createElement("br", null) : null, /*#__PURE__*/_react.default.createElement("span", {
        className: "airdate-formatter__central-time"
      }, centralTime, /*#__PURE__*/_react.default.createElement("span", null, "c"))));
    case 'none':
    default:
      return /*#__PURE__*/_react.default.createElement("airdate-formatter", null, /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _helpers.classes)([_AirDateFormatterModule.default['airdate-formatter__date'], 'airdate-formatter__date'])
      }, daySection === 'Today' || daySection === 'Tomorrow' ? daySection : "".concat(daySection, ", ").concat(dateSection)), "\xA0", /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _helpers.classes)([_AirDateFormatterModule.default['airdate-formatter__time-wrap'], 'airdate-formatter__time-wrap'])
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "airdate-formatter__time"
      }, timeSection), "/", /*#__PURE__*/_react.default.createElement("span", {
        className: "airdate-formatter__central-time"
      }, centralTime, /*#__PURE__*/_react.default.createElement("span", null, "c"))));
  }
}
var _default = exports.default = AirDateFormatter;